import type { RouteLocationNormalized } from '#vue-router'

export const useLoadMediasReviewsCommunity = () => {
  const communitiesStore = useCommunitiesStore()
  const mediasStore = useMediasStore()

  return async (route: RouteLocationNormalized) => {
    await Promise.all([
      // Fetch data about the community
      communitiesStore.fetchCommunity({
        slug: route.params.communityName as string,
      }),
      // Fetch media reviews from the community
      mediasStore.fetchCommunityMedias({
        page: getPageQuery(route),
        community: route.params.communityName as string,
      }),
    ])

    throwIfNotFound(communitiesStore.community)

    if (mediasStore.getCommunityPagesCount === -1) {
      return navigateTo(route.path, { replace: true })
    }
  }
}
